import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from './axios';

const AuthContext = createContext();

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;


// Provider component

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); 
  const [isAuthenticated, setIsAuthenticated] = useState(false);


  const checkSession = async () => {
    try {
      const res = await axios.get('/me/');
      if (res.status === 200) {
        setUser(res.data);
        setIsAuthenticated(true);
      } else {
        setUser(null);
        setIsAuthenticated(false);
      }
    } catch (err) {
      setUser(null);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    checkSession();  
  }, []);  


  const login = async (username, password) => {
    try {
      const csrfRes = await axios.get('csrf/', { withCredentials: true });
      const csrfToken = csrfRes.data.csrfToken;
  
      await axios.post(
        'login/',
        { username, password },
        {
          withCredentials: true,
          headers: {
            'X-CSRFToken': csrfToken,
          },
        }
      );
  
      const res = await axios.get('me/', { withCredentials: true });
      setUser(res.data);
    } catch (error) {
      setUser(null);
      throw error;
    }
  };
  

  const logout = async () => {
    try {
      await axios.get('csrf/');
  
      await axios.post('logout/',{});
      setUser(null);
    } catch (error) {
      console.error('Logout failed', error);
    }
  };


  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated, checkSession, loading }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => React.useContext(AuthContext);
